module.exports = __webpack_public_path__ + "static/media/1.673a920f.jpg";